import enum_Transformed from "@/utils/enum_Transformed";

// 培训方式
export const DEVICE_TYPE_MAP = enum_Transformed({
    1: "坦克车",
    2: "人偶",
    3: "机器狗",
    4: "机器鸭",
    5: "坡豆智能体套装",
});
